import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, Users, Sparkles } from "lucide-react";
import { Button } from "../components/ui/button";
import { FourStars, StarsDivider } from "../components/FourStars";

const PROGRAMS = [
  { title: "Solidarité Éducation", text: "Manuels et fournitures pour les enfants des zones défavorisées.", img: "https://images.unsplash.com/photo-1544717305-2782549b5136?auto=format&fit=crop&w=1000&q=80" },
  { title: "Solidarité Santé", text: "Soutien aux maternités gratuites et campagnes de vaccination.", img: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?auto=format&fit=crop&w=1000&q=80" },
  { title: "Solidarité Jeunesse", text: "Bourses, formations et insertion professionnelle des jeunes.", img: "https://images.unsplash.com/photo-1758875913518-7869eb5e1e91?auto=format&fit=crop&w=1000&q=80" },
];

export default function SolidarityPage() {
  return (
    <div data-testid="solidarity-page">
      <section className="relative py-24 md:py-32 text-white overflow-hidden">
        <div className="absolute inset-0" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1758875913518-7869eb5e1e91?auto=format&fit=crop&w=1920&q=80)`, backgroundSize: "cover", backgroundPosition: "center" }} />
        <div className="absolute inset-0 hero-overlay" />
        <div className="relative max-w-5xl mx-auto px-6 md:px-10 text-center">
          <FourStars size={14} className="justify-center mb-4" />
          <div className="text-xs uppercase tracking-[0.3em] text-[#D4AF37]">Solidarité</div>
          <h1 className="font-display text-4xl md:text-6xl mt-3 leading-tight">L'union du peuple congolais</h1>
          <p className="text-white/80 mt-6 text-lg max-w-2xl mx-auto leading-relaxed">
            Nous croyons en une RDC unie, où chaque citoyen tend la main à son prochain. Découvrez nos programmes solidaires.
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {PROGRAMS.map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.06 }}
                className="bg-white rounded-2xl overflow-hidden border border-black/5 shadow-sm hover:shadow-xl transition-all"
                data-testid={`solidarity-program-${i}`}
              >
                <img src={p.img} alt={p.title} className="w-full aspect-[16/10] object-cover" />
                <div className="p-7">
                  <h3 className="font-display text-2xl text-[#0A0F1A]">{p.title}</h3>
                  <p className="text-sm text-[#475569] mt-3 leading-relaxed">{p.text}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <StarsDivider />

          <div className="text-center max-w-2xl mx-auto">
            <h2 className="font-display text-3xl md:text-4xl text-[#0A0F1A]">La solidarité, un acte concret.</h2>
            <p className="text-[#475569] mt-4 leading-relaxed">
              Rejoignez notre communauté ou faites un don pour soutenir nos programmes.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-3 mt-8">
              <Button asChild size="lg" className="bg-[#D4AF37] hover:bg-[#B5952F] text-[#0A0F1A] rounded-sm">
                <Link to="/dons"><Heart className="mr-2" size={18} /> Faire un don</Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="border-[#0052CC] text-[#0052CC] rounded-sm">
                <Link to="/register"><Users className="mr-2" size={18} /> Devenir membre</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
